import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { v4 as uuidv4 } from "uuid";

import { Image } from "../../../AbstractElements";
import { CountryList } from "../../../data/holidays/CountryList";
import { dynamicImageflags } from "../../../service";
import { Link, useNavigate } from "react-router-dom";
 import CardHeaderCommon from "../../../common-elements/card-header-common/CardHeaderCommon";
import NavigationBreadcrumbs from "../../../common-elements/breadcrumbs/NavigationBreadcrumbs";
 
export default function TaxCountryList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const oHandleClickTaxTypes = (countryName: string) => {
    navigate(
      `${process.env.PUBLIC_URL}/tax-types/country/${encodeURIComponent(
        countryName
      )}`
    );
  };
  return (
    <>
        <NavigationBreadcrumbs
        mainTitle={t("TaxTypes")}
        parent={t("Master Data")}
        links={[
          { label: "Tax Types", active: true },
        ]}
      />
      <Container fluid>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <div className="d-flex justify-content-between align-items-center mb-3 ">
                  <CardHeaderCommon title={t("Countries")} />

                  <div className="d-flex gap-2">
                    <Link
                      className="btn btn-primary"
                      to={`${process.env.PUBLIC_URL}/masterdata/add-tax-type`}
                    >
                      <i className="fa fa-plus" />
                      {t("AddTaxTypes")}
                    </Link>
                  </div>
                </div>
              </div>
              <Row className="g-sm-4 g-3">
                {CountryList.map((country) => (
                  <Col xl="4" md="6" key={uuidv4()}>
                    <div
                      className="prooduct-details-box"
                      style={{ cursor: "pointer" }}
                      onClick={() => oHandleClickTaxTypes(country.name)}
                    >
                      <div className="d-flex" style={{ gap: window.innerWidth <= 428 ? '8px' : '12px' }}>
                        <Image
                          className="align-self-center img-fluid img-60"
                          src={dynamicImageflags(`flag-icon/${country.image}`)}
                          alt="#"
                        />
                        <div className="flex-grow-1 ms-3">
                          <div>
                            <div>{country?.name}</div>
                          </div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </>
  );
}
